import { ShieldOff } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { errorMessage } from '@/lib/api/errors'
import { useResetTwoFactor } from './api'

/**
 * Someone on the workspace lost their phone and their recovery codes: turn off their two-step
 * verification. Only once they've shown it's them (for example, writing from the account's
 * email). They're emailed about it, and it's in the audit log.
 */
export function TwoFactorReset({
  customerId,
  userId,
  email,
}: {
  customerId: string
  userId: string
  email: string
}) {
  const reset = useResetTwoFactor(customerId)
  const [confirming, setConfirming] = useState(false)

  if (!confirming) {
    return (
      <Button size="sm" variant="ghost" onClick={() => setConfirming(true)}>
        <ShieldOff /> Turn off
      </Button>
    )
  }

  return (
    <div className="grid gap-2 text-xs text-ink-muted" style={{ maxWidth: 260, whiteSpace: 'normal' }}>
      <span>
        Only after {email} has shown it’s them, for example by writing from that address. They’re emailed.
      </span>
      <span className="flex flex-wrap gap-2">
        <Button
          size="sm"
          variant="danger"
          loading={reset.isPending}
          onClick={() =>
            reset.mutate(userId, {
              onSuccess: (r) => {
                toast.success(r.message)
                setConfirming(false)
              },
              onError: (e) => toast.error(errorMessage(e)),
            })
          }
        >
          Turn off two-step
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setConfirming(false)}>
          Cancel
        </Button>
      </span>
    </div>
  )
}
